import { useCallback, useRef } from "react";
import { useHistory } from "react-router-dom";
import { EpisodeAccessType, Program } from "../../modules/graphql/api.generated";
import { useHeroSectionMutator } from "../../modules/shared/heroSection/heroSectionContext/heroSectionContextHooks";
import { FocusableComponentLayout, FocusContext, useFocusable } from "../../modules/spatialNavigation";
import MovieCard from "../shared/movieCard/MovieCard";
import SliderLoadMoreButtonComponent from "../shared/SliderLoadMoreButton/SliderLoadMoreButton";
import * as styles from "./styles.module.scss";

interface IProps {
  data: Program[];
  title: string;
  focusKey?: string;
  hasMorePage: boolean;
  loadNextPage: () => void;
  onAssetPress?: (program: Program) => void;
  onFocus?: (layout: FocusableComponentLayout) => void;
}
const BookmarkRowSection = (props: IProps) => {
  const history = useHistory();
  const dispatchHeroSection = useHeroSectionMutator();
  const scrollingRef = useRef<any>(null);

  const { ref, focusKey } = useFocusable({
    onFocus: (l) => {
      props.onFocus(l);
    },
    focusBoundaryDirections: ["left"],
    autoRestoreFocus: true,
    isFocusBoundary: true,
  });
  const onAssetFocus = useCallback(
    (l: FocusableComponentLayout, index: number) => {
      scrollingRef.current.style.transform = `translateX(${index * (l.width + 8)}px)`;
      scrollingRef.current.style["-webkit-transform"] = `translateX(${index * (l.width + 8)}px)`;
    },
    [scrollingRef],
  );
  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles.rowContainer}>
        <div className={styles.rowTitle}>{props.title}</div>
        <div className={styles.scrollingContainer + " " + styles.rowBox} ref={scrollingRef}>
          {props.data?.map((item, index) => (
            <MovieCard
              key={`category-movie-card-${index}`}
              imagePath={item.landscapeImagePath}
              link={`/p/${item.uid}`}
              isExclusive={item?.isExclusive}
              isFree={item?.episode?.accessType === EpisodeAccessType.Free}
              index={index}
              focusKey={props.focusKey + "-" + item.id}
              onEnterPress={() => {
                history.push(`/p/${item.uid}`);
              }}
              onFocus={(l) => {
                onAssetFocus(l, index);
                dispatchHeroSection({
                  imagePath: item.bannerImagePath,
                  description: item.description,
                  typoGraphyImagePath: item.typoGraphyImagePath,
                  programUid: item.uid,
                });
              }}
            />
          ))}
          {props.hasMorePage && props.data?.length > 0 && (
            <SliderLoadMoreButtonComponent focusKey="loadMoreButton" onClick={props.loadNextPage} />
          )}
        </div>
      </div>
    </FocusContext.Provider>
  );
};
export default BookmarkRowSection;
